<template>
  <v-snackbar v-model="snackbar.show" :color="snackbar.color" multi-line absolute bottom right>
    {{ snackbar.text }}
  </v-snackbar>
</template>

<script>
import useSnackbarNotifications from '../views/Context/use/useSnackbarNotifications';
export default {
  name: 'snackbarNotifications',
  setup() {
    const { snackbar, updateSnackbar } = useSnackbarNotifications();
    return { snackbar, updateSnackbar };
  }
};
</script>
